import { render, staticRenderFns } from "./allotTask.vue?vue&type=template&id=526ab3d2&scoped=true"
import script from "./allotTask.vue?vue&type=script&lang=js"
export * from "./allotTask.vue?vue&type=script&lang=js"
import style0 from "./allotTask.vue?vue&type=style&index=0&id=526ab3d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526ab3d2",
  null
  
)

export default component.exports